import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-file-error-popup',
  standalone: false,
  templateUrl: './file-error-popup.component.html',
  styleUrl: './file-error-popup.component.scss'
})
export class FileErrorPopupComponent {
title:string = 'Oops! Unsupported File Format.';
message:string = 'Please select a file in one of the following formats: [List of accepted formats].';
  constructor(public dialogRef: MatDialogRef<FileErrorPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.title=data.title;
      this.message=data.message
      dialogRef.disableClose = true;
    }

  onCloseBtn(){
    this.dialogRef.close({ operation: 'close' });
  }
  
  onTryFile(){
    this.dialogRef.close({ operation: 'try' });
  }
  
}

